import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { listStyles } from "@insite/content-library/Widgets/Brand/BrandGallery";
import { css } from "styled-components";

listStyles.image = mergeToNew(listStyles.image, {
    css: css`
        background: white;
    `,
});
